import { styled } from "@mui/material";
import { Header as VoltHeader, MenuIcon } from "@volt_developers/components";

import { Avatar, Breadcrumbs, EnvironmentSwitcher } from "../../components";
import { TEST_IDS } from "../../constants/TestIds";

interface HeaderProps {
  onMenuClick: () => void;
}

export function Header({ onMenuClick }: HeaderProps) {
  return (
    <VoltHeader.Wrapper>
      <VoltHeader.Navigation>
        <MenuIconWrapper
          data-testid={TEST_IDS.headerToggleSidebar}
          onClick={onMenuClick}
        >
          <MenuIcon />
        </MenuIconWrapper>
        <Breadcrumbs />
      </VoltHeader.Navigation>
      <VoltHeader.Action>
        <EnvironmentSwitcher />
        <Avatar />
      </VoltHeader.Action>
    </VoltHeader.Wrapper>
  );
}

const MenuIconWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  margin: theme.spacing(0, 2.5),
  cursor: "pointer",
  color: theme.palette.primary.main,
  fontSize: 24,
}));
